const foodTypeObj = {
  staple_num: {
    name: '碳水',
    color: '#A1DBF0'
  },
  protein_num: {
    name: '蛋白质',
    color: '#FFD879'
  },
  vegetable_num: {
    name: '蔬菜',
    color: '#C0E9BA'
  },
  drink_num: {
    name: '饮品',
    color: '#DED4FF'
  }
}
//保存各类食物的主题颜色
const colorData = {
  碳水: {
    color1: '#A1DBF0', //图表颜色
    color2: 'linear-gradient(135deg, #CFEFF9 0%, #A1DBF0 100%)', //标题背景渐变色
    color3:
      'linear-gradient(360deg, rgba(207,239,249,0.12) 0%, rgba(161,219,240,0.2) 100%)', //内容渐变色
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ab847867d263a5c63252bcb3a2dbb9c4.png' //图标
  },
  蛋白质: {
    color1: '#FFD879',
    color2: 'linear-gradient(135deg, #FFEEB1 0%, #FFD879 100%)',
    color3:
      'linear-gradient(360deg, rgba(255,238,177,0.12) 0%, rgba(255,216,121,0.2) 100%)',
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cfd02ea39c0e8c21608a0a32001f869b.png'
  },
  蔬菜: {
    color1: '#C0E9BA',
    color2: 'linear-gradient(135deg, #D8F4D4 0%, #BDEAB7 100%)',
    color3:
      'linear-gradient(360deg, rgba(216,244,212,0.12) 0%, rgba(189,234,183,0.2) 100%)',
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8c00fa965f4975ea3bf16755ac08bfcf.png'
  },
  饮品: {
    color1: '#6236FF',
    color2: 'linear-gradient(135deg, #ECE5FF 0%, #DED4FF 100%',
    color3:
      'linear-gradient(360deg, rgba(236,229,255,0.12) 0%, rgba(222,212,255,0.2) 100%)',
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/802647cc8a3a623fc6b1d3d4f7cfbca8.png'
  }
}
const recommendData = []
const recommendTotalData = [
  {
    name: '碳水',
    weight: '300'
  },
  {
    name: '蛋白质',
    weight: '120'
  },
  {
    name: '蔬菜',
    weight: '200'
  }
]
const getQuestionData = function () {
  return [
    {
      index: 1,
      field: 'height',
      field_title: '身高',
      field_type: 'int',
      field_unit: '厘米',
      value: '',
      valueText: '',
      extra: '',
      data_type: '',
      data_num: '',
      defaultNum: 160,
      minNum: 100,
      maxNum: 250
    },
    {
      index: 2,
      field: 'weight',
      field_title: '当前体重',
      field_type: 'int',
      field_unit: '千克',
      value: '',
      valueText: '',
      extra: '',
      data_type: '',
      data_num: '',
      defaultNum: 55,
      minNum: 30,
      maxNum: 200
    },
    {
      index: 3,
      field: 'target_weight',
      field_title: '目标体重',
      field_type: 'int',
      field_unit: '千克',
      value: '',
      valueText: '',
      extra: '',
      data_type: '',
      data_num: '',
      defaultNum: 55,
      minNum: 30,
      maxNum: 200
    },
    {
      index: 4,
      field: 'age',
      field_title: '年龄',
      field_type: 'int',
      field_unit: '岁',
      value: '',
      valueText: '',
      extra: '',
      data_type: '',
      data_num: '',
      defaultNum: 20,
      minNum: 12,
      maxNum: 120
    },
    {
      index: 5,
      field: 'sex',
      field_title: '性别',
      field_type: 'radio',
      field_unit: [
        {
          key: '男',
          value: '男'
        },
        {
          key: '女',
          value: '女'
        }
      ],
      value: '',
      valueText: '',
      extra: '',
      data_type: '',
      data_num: ''
    },
    {
      index: 6,
      field: 'exercise_intensity',
      field_title: '运动频率',
      sub_text: '',
      field_type: 'radio',
      field_unit: [
        {
          key: 'a',
          value: '基本不运动'
        },
        {
          key: 'b',
          value: '偶尔运动(一周2到3次)'
        },
        {
          key: 'c',
          value: '经常运动(一周4到5次)'
        },
        {
          key: 'd',
          value: '高强度规律运动(运动员)'
        }
      ],
      value: '',
      valueText: '',
      extra: '',
      data_type: '',
      data_num: ''
    }
  ]
}
export {
  recommendData,
  recommendTotalData,
  colorData,
  getQuestionData,
  foodTypeObj
}
